import React, { Component } from "react";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import {
  Button,
  Form,
  Input,
  Select,
  Dropdown,
  Space,
  Popover,
  message,
  Modal,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
  CopyOutlined,
  SaveOutlined,
  SendOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import axios from "axios";
import { conditionsValidator } from "./utils/conditionsValidator";

class ContractEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      publishValidation: false,
      openAlert: false,
      wasEdited: false,
      openPopover: false,
      viewMode: false,
      editCondition: {
        title: "",
        text: "",
        modality: "residential",
        isPublished: false,
        author_uuid: "",
      },
      formErrors: {},
    };
    this.formRef = React.createRef();
    this.handleRichTextChange = this.handleRichTextChange.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    const queryParams = new URLSearchParams(this.props.location.search);
    const viewMode = Boolean(queryParams.get("view"));
    this.setState({ viewMode: viewMode });

    if (id !== "nueva-revision") {
      axios
        .get(`https://backoffice.nadu.xyz/api/contract-conditions/${id}`)
        .then((res) => {
          if (typeof res !== "undefined") {
            const fullResponse = res.data.data;
            const formatted = {
              id: fullResponse.id,
              uuid: fullResponse.attributes.uuid,
              title: fullResponse.attributes.title,
              text: fullResponse.attributes.text,
              modality: fullResponse.attributes.modality,
              author_uuid: fullResponse.attributes.author_uuid,
              isPublished: fullResponse.attributes.isPublished,
            };
            this.setState({ editCondition: formatted }, () => {
              if (this.formRef.current) {
                this.formRef.current.setFieldsValue({
                  title: this.state.editCondition.title,
                });
              }
            });
          }
        });
    }
  }
  handleCancel() {
    this.setState({
      wasEdited: false,
      viewMode: false,
      editCondition: {
        title: "",
        text: "",
        modality: "residential",
        isPublished: false,
        author_uuid: "",
      },
    });
    this.props.history.push(`/backoffice/condiciones-contratacion/`);
  }
  validateAndSetErrors() {
    const { editCondition } = this.state;
    const errors = conditionsValidator(editCondition);
    this.setState({ formErrors: errors });
  }
  handleRichTextChange(content) {
    this.setState(
      {
        wasEdited: !this.state.viewMode,
        editCondition: {
          ...this.state.editCondition,
          text: content,
        },
      },
      () => this.validateAndSetErrors()
    );
  }
  handleChange(prop, event) {
    this.setState({
      wasEdited: true,
    });
    if (prop) {
      this.setState(
        {
          editCondition: {
            ...this.state.editCondition,
            [prop]: event,
          },
        },
        () => this.validateAndSetErrors()
      );
    } else {
      const { name, value } = event.target;
      this.setState(
        {
          editCondition: {
            ...this.state.editCondition,
            [name]: value,
          },
        },
        () => this.validateAndSetErrors()
      );
    }
  }
  async handleDelete(contract_id) {
    try {
      if (contract_id) {
        const result = await axios.delete(
          `https://backoffice.nadu.xyz/api/contract-conditions/${contract_id}`
        );
        if (result.data.error) {
          message.error(result.data.error);
        } else {
          message.success("Borrador eliminado correctamente");
          this.props.history.push("/backoffice/condiciones-contratacion");
        }
      } else this.props.history.push("/backoffice/condiciones-contratacion");
    } catch (error) {
      message.error(JSON.parse(error));
    }
  }
  async handlePublish(contract_id) {
    try {
      const result = await axios.put(
        `https://backoffice.nadu.xyz/api/publish-contract/${contract_id}`
      );
      if (result.data.error) {
        message.error(result.data.error);
      } else {
        message.success("Condiciones de contratación creadas correctamente");
        this.setState({ viewMode: true });
      }
    } catch (error) {
      message.error(JSON.parse(error));
    }
  }
  async handleSubmitChanges(contract_id) {
    try {
      const { editCondition } = this.state;
      const result = await axios.put(
        `https://backoffice.nadu.xyz/api/contract-conditions/${contract_id}`,
        {
          title: editCondition.title,
          text: editCondition.text,
          collaborator_uuid: editCondition.author_uuid,
          modality: editCondition.modality,
        }
      );
      if (result.data.error) {
        message.error(result.data.error);
      } else {
        message.success("Cambios guardados correctamente");
        this.setState({ viewMode: true, wasEdited: false });
      }
    } catch (error) {
      message.error(JSON.parse(error));
    }
  }
  async handleNewRevision() {
    try {
      const { editCondition } = this.state;
      const result = await axios.post(
        "https://backoffice.nadu.xyz/api/contract-conditions/",
        {
          title: editCondition.title,
          text: editCondition.text,
          author_uuid: editCondition.author_uuid,
          modality: editCondition.modality,
        }
      );
      if (result.data.error) {
        message.error(result.data.error);
      } else {
        const fullResponse = result.data;
        const formatted = {
          id: fullResponse.id,
          uuid: fullResponse.uuid,
          title: fullResponse.title,
          text: fullResponse.text,
          modality: fullResponse.modality,
          author_uuid: fullResponse.author_uuid,
          isPublished: fullResponse.isPublished,
        };
        message.success("Nueva revisión creada");
        this.setState({ viewMode: false, editCondition: formatted });
      }
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const ifPublished = [
      {
        label: "Nueva Revisión",
        key: "review-conditions",
        icon: <CopyOutlined />,
        onClick: () => {
          this.setState({
            wasEdited: true,
            viewMode: false,
          });
          this.props.history.push(
            `/backoffice/condiciones-contratacion/nueva-revision`
          );
          this.handleNewRevision();
        },
      },
    ];
    const ifViewMode = [
      {
        label: "Editar Condiciones",
        key: "edit-conditions",
        icon: <EditOutlined />,
        onClick: () => this.setState({ viewMode: false }),
      },
      {
        label: "Nueva Revisión",
        key: "review-conditions",
        icon: <CopyOutlined />,
        disabled: !this.state.editCondition.isPublished,
        onClick: () => {
          this.props.history.push(
            `/backoffice/condiciones-contratacion/nueva-revision`
          );
          this.handleNewRevision();
        },
      },
      {
        label: "Publicar Condiciones",
        key: "publish-conditions",
        icon: <SendOutlined />,
        onClick: () => this.setState({ publishValidation: true }),
      },
      {
        danger: true,
        label: "Eliminar Borrador",
        key: "delete-conditions",
        icon: <DeleteOutlined />,
        onClick: () => this.setState({ openAlert: true }),
      },
    ];
    const ifEditMode = [
      {
        label: "Guardar Cambios",
        key: "save-changes",
        icon: <SaveOutlined />,
        disabled:
          Object.values(this.state.formErrors).length > 0 ||
          this.state.editCondition.title.length < 1,
        onClick: () => {
          if (this.state.editCondition.id) {
            this.handleSubmitChanges(this.state.editCondition.id);
          } else {
            this.handleNewRevision();
            this.setState({ viewMode: true });
          }
        },
      },
      {
        label: "Publicar Condiciones",
        key: "publish-conditions",
        icon: <SendOutlined />,
        disabled:
          this.state.wasEdited ||
          Object.values(this.state.formErrors).length > 0 ||
          this.state.editCondition.title.length < 1,
        onClick: () => this.setState({ publishValidation: true }),
      },
      {
        danger: true,
        label: "Eliminar Borrador",
        key: "delete-conditions",
        icon: <DeleteOutlined />,
        onClick: () => this.setState({ openAlert: true }),
      },
    ];
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card style={{ height: "100%" }}>
                <CardHeader
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edición de condición de contratación</h5>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <Popover
                      placement="bottom"
                      content={
                        <Space>
                          <Button onClick={() => this.handleCancel()}>
                            Descartar
                          </Button>
                          <Button
                            onClick={() => {
                              if (this.state.editCondition.id) {
                                this.handleSubmitChanges(this.state.editCondition.id);
                              } else {
                                this.handleNewRevision();
                                this.setState({ viewMode: true });
                              }
                              this.props.history.push(
                                "/backoffice/condiciones-contratacion/"
                              );
                            }}
                            type="primary"
                          >
                            Guardar
                          </Button>
                        </Space>
                      }
                      title="Tienes cambios sin guardar"
                      trigger="click"
                      open={this.state.openPopover}
                    >
                      <Button
                        onClick={() =>
                          this.state.wasEdited
                            ? this.setState({ openPopover: true })
                            : this.handleCancel()
                        }
                      >
                        Volver
                      </Button>
                    </Popover>
                    <Dropdown
                      menu={{
                        items: this.state.editCondition.isPublished
                          ? ifPublished
                          : this.state.viewMode
                            ? ifViewMode
                            : ifEditMode,
                      }}
                      placement="bottom"
                    >
                      <Button>
                        <Space>
                          Acciones
                          <div className="acciones-contrato">
                            <MoreOutlined />
                          </div>
                        </Space>
                      </Button>
                    </Dropdown>
                  </div>
                </CardHeader>
                <CardBody style={{ height: "100%" }}>
                  <Form ref={this.formRef} layout="vertical" hideRequiredMark>
                    <Row
                      span={24}
                      style={{
                        padding: "6px 30px",
                        gap: "8px",
                      }}
                    >
                      <Form.Item
                        name="title"
                        label="Titulo"
                        style={{ flex: 1 }}
                        validateStatus={
                          this.state.formErrors.title ? "error" : ""
                        }
                        help={
                          this.state.formErrors.title
                            ? this.state.formErrors.title
                            : ""
                        }
                      >
                        <Input
                          name="title"
                          defaultValue={this.state.editCondition.title}
                          disabled={this.state.viewMode}
                          onChange={(event) => this.handleChange(null, event)}
                          placeholder="Ingresa el título"
                        />
                      </Form.Item>
                      <Form.Item
                        name="modality"
                        label="Modalidad"
                        style={{ flex: 1 }}
                      >
                        <Select
                          disabled={this.state.viewMode}
                          defaultValue={
                            this.state.editCondition &&
                            this.state.editCondition.modality
                          }
                          onChange={(value) =>
                            this.handleChange("modality", value)
                          }
                        >
                          <Select.Option value="business">
                            Empresas
                          </Select.Option>
                          <Select.Option value="residential">
                            Residencial
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Row>
                  </Form>
                  <Col span={24} style={{ marginTop: 20, paddingBottom: 20 }}>
                    <p style={{ color: "red", margin: 1 }}>
                      {this.state.formErrors.text
                        ? this.state.formErrors.text
                        : ""}
                    </p>
                    <ReactQuill
                      theme="snow"
                      readOnly={this.state.viewMode}
                      value={this.state.editCondition.text}
                      onChange={this.handleRichTextChange}
                      style={{ height: "550px" }}
                    />
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {/* Delete Validation Modal  */}
        <Modal
          open={this.state.openAlert}
          title="Eliminar elemento"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button onClick={() => this.setState({ openAlert: false })}>
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handleDelete(this.state.editCondition.id);
                  this.setState({ openAlert: false });
                }}
                type="primary"
                danger={true}
              >
                Eliminar
              </Button>
            </div>
          )}
        >
          ¿Deseas eliminar el elemento?
        </Modal>
        {/* Publish Validation Modal  */}
        <Modal
          open={this.state.publishValidation}
          title="¿Deseas publicar este documento?"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button
                onClick={() => this.setState({ publishValidation: false })}
              >
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handlePublish(this.state.editCondition.id);
                  this.setState({ publishValidation: false });
                }}
                type="primary"
              >
                Publicar
              </Button>
            </div>
          )}
        >
          Una vez publicado, no podrás volver a editarlo.
        </Modal>
      </div>
    );
  }
}

export default ContractEdit;



// WEBPACK FOOTER //
// ./src/views/Configurator/ContractEdit.jsx